<template>
  <div>
    <section>
      <v-parallax :src="heroAsset" height="400">
        <v-layout column align-center justify-center class="white--text">
          <v-avatar :size="150" color="grey lighten-4 mb-4">
            <img class="logoImg" :src="logoAsset" alt="Logo" />
          </v-avatar>
          <h1 class="white--text mb-2 display-1 text-xs-center image-title">
            {{ expertise }}
          </h1>
          <!-- <div class="subheading mb-3 text-xs-center">Powered by Vuetify</div> -->
          <!-- <v-btn class="primary mt-3 white--text" large :to="{name:'overmij'}">Over mij</v-btn> -->
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-layout column align-center justify-center class="my-4">
        <v-flex xs12>
          <div class="text-xs-center">
            <sv-page-title title="NGS Sportmasseur van het jaar 2019!" />
            <span class="title">Diensten</span>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-container grid-list-xl>
            <v-layout justify-space-between wrap row>
              <v-flex
                xs12
                sm4
                v-for="(service, index) in services"
                :key="index"
              >
                <v-card class="elevation-0 transparent">
                  <v-card-title primary-title class="layout justify-center">
                    <div class="headline text-xs-center">
                      {{ service.title }}
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <editable-field
                      :field-id="service.fieldId"
                      v-if="fields"
                    ></editable-field>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout justify-center row>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-menu offset-y>
                    <v-btn slot="activator" class="primary white--text"
                      >Lees meer</v-btn
                    >
                    <v-list class="py-0">
                      <v-list-tile
                        v-for="(service, index) in services"
                        :key="index"
                        :to="{ name: service.link }"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>{{
                            service.title
                          }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax :src="sectionAsset" height="300">
        <v-layout column align-center justify-center>
          <div class="headline image-title white--text mb-3 text-xs-center">
            {{ nieuws }}
          </div>
          <!-- <em class="image-title">Kick-start your application today</em> -->
          <v-btn class="primary mt-3 white--text" large :to="{ name: 'nieuws' }"
            >Nieuws</v-btn
          >
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-5">
          <v-flex xs12 sm4>
            <sv-page-title title="Over Sana Vita" class="text-xs-center" />
            <company-info />
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <sv-page-title title="Neem contact op" class="text-xs-center" />
            <contact-info />
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      expertise: "Welkom op de website van Sana Vita",
      services: [
        {
          title: "Sportmassage",
          fieldId: "home_sportmassage",
          link: "sportmassage"
        },
        {
          title: "Ontspanningsmassage",
          fieldId: "home_ontspanningsmassage",
          link: "ontspanningsmassage"
        },
        {
          title: "Medical taping",
          fieldId: "home_medicaltaping",

          link: "medicaltaping"
        }
      ],
      nieuws: "Volg Sana Vita op Facebook!"
    };
  },
  computed: {
    heroAsset() {
      return require("@/assets/sv/headers/home1.jpg");
    },
    sectionAsset() {
      return require("@/assets/sv/headers/home2.jpg");
    },
    logoAsset() {
      return require("@/assets/sv/logo/logo_complete.png");
    },
    fields() {
      return this.$store.getters.fields;
    }
  }
};
</script>

<style lang="scss" scoped>
.logoImg {
  width: 95%;
  border-radius: 0;
  height: auto;
}
</style>
